import React from "react";
import { createProjectQueries } from "../graph";
import _ from "lodash";

import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { SchemaForm, utils } from "components/material-ui-schema-form/index";
import {createProjectsStyle} from "../style";
import withStyles from "material-ui/styles/withStyles";

import Button from "components/CustomButtons/Button.jsx";
import IconButton from "material-ui/IconButton";
import Close from "@material-ui/icons/Close";


import Dialog from "material-ui/Dialog";
import DialogTitle from "material-ui/Dialog/DialogTitle";
import DialogContent from "material-ui/Dialog/DialogContent";
import DialogActions from "material-ui/Dialog/DialogActions";
import Slide from "material-ui/transitions/Slide";
import { getProjectsQuery } from "../graph";
import gql from 'graphql-tag';

function Transition(props) {
  return <Slide direction="down" {...props} />;
}

class CreateProjectModal extends React.Component {
  constructor(props){
      super(props)
      this.state = {
          model: {
            "clientCode": "",
            "manager": "",
            "language": "",
            "country": "",
            "collection":"1",
            "projectid":"",
          },
      };
      this.form = ["clientCode",
                    "manager",
                    "language",
                    "projectid",
                    "country",{
                    "titleMap": [
                          {
                            "value": "1",
                            "name": "Conversational"
                          },
                          {
                            "value": "2",
                            "name": "Scripted"
                          }
                    ],
                    "key":"collection",
                    "type":"select",
      }];
      this.schema = {
      "type": "object",
      "properties": {
        "manager": {
          "type":"string",
          "maxLength":150
        },
        "clientCode": {
          "type":"string",
          "maxLength":25
        },
        "language": {
          "type":"string",
          "maxLength":3
        },
        "projectid": {
          "type":"integer"
        },
        "country": {
          "type":"string",
          "maxLength":3
        },
        "collection": {
          "type": "string",
          "enum": ["1","2"],
          "enumNames": ["conversational","scripted"]
        }, 
      }
    };
      //this.onSubmitHandler = this.onSubmitHandler.bind(this);
  }
  onModelChange(key, val){
    let newModel = this.state.model;
    let value = utils.selectOrSet(key, newModel, val);
    this.setState({ model: newModel });
  }
  onSubmitHandler(event){
      let result = utils.validateBySchema(this.schema, this.state.model);
      
      let _this = this;
      this.props.createProject({ variables: { 
              name: this.state.model.clientCode, 
              collectiontype: this.state.model.collection, 
              language: this.state.model.language,
              country: this.state.model.country, 
              projid: this.state.model.projectid, 
              manager: this.state.model.manager
          }, 
          refetchQueries: (mutationResult) => [ 
            { query:  getProjectsQuery, 
              variables: {
                filterBy: JSON.stringify([]),
                offset: _this.props.lastPage, 
                pageSize: 10,
                sort: JSON.stringify([])
              }, 
              options: {
                fetchPolicy: 'no-cache'
              }
          }]
      }).then((data) => {
          if(!_.isEmpty(data.errors)){
            var obj = JSON.parse(data.errors[0].message);

            _this.props.showNotification(obj.message,"danger","tc");
          }
          else{
            _this.props.createProjectsModalClose();
            _this.props.projectRefresh("Successfully created project"); 
          }
          
      }).catch(({errors}) => {
          console.log(errors);
      })
  }
  render(){
    const { classes } = this.props;
    return(
      <form onSubmit={this.onSubmitHandler.bind(this)}>
      <Dialog
        classes={{
          root: classes.center,
          paper: classes.modal
        }}
        open={this.props.createProjectsModalIsOpen}
        //transition={Transition}
        keepMounted
        onClose={this.props.createProjectsModalClose}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <IconButton
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="inherit"
          >
          
          </IconButton>
          <h4 className={classes.modalTitle}>Modal title</h4>
        </DialogTitle>
        <DialogContent
          id="classic-modal-slide-description"
          className={classes.modalBody}
        >
          <SchemaForm 
            schema={this.schema}
            form={this.form}
            model={this.state.model}
            onModelChange={this.onModelChange.bind(this)}
          >
            
          </SchemaForm>
        </DialogContent>
        <DialogActions className={classes.modalFooter}>
          <Button color="rose" onClick={this.onSubmitHandler.bind(this)}>Create</Button>
          <Button
            onClick={this.props.createProjectsModalClose}
            color="dangerNoBackground"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </form>
    )
  }
}

export default withStyles(createProjectsStyle)((createProjectQueries)(CreateProjectModal));


// WEBPACK FOOTER //
// ./src/views/projects/components/Create.js